import { useTranslation } from 'react-i18next';
import { Tooltip } from '@/components/Tooltip';

export function TimerTooltip({ children }) {
	const { t } = useTranslation();

	return <Tooltip title={t('myImages.timerTooltip')}>{children}</Tooltip>;
}
